<template>
    <div>
        <div class="row">
            <div class="mb-3 col-12" v-if="errorMessage.length > 0">
                <div class="card card-text bg-error">
                    <div class="d-flex col-12 justify-content-center align-items-center p-3">
                        <i class="bi bi-exclamation-lg me-2"></i>
                        <p class="mb-0">{{ errorMessage }}</p>
                    </div>
                </div>
            </div>

            <div class="mb-3 col-md-6">
                <label for="name_user" class="form-label fw-bold">Nom*</label>
                <input type="text" class="form-control" id="name_user" placeholder="Nom" v-model="formData.name"
                    required>
                <small class="text-danger" v-if="errors['name']">{{ errors['name'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="prenoms_user" class="form-label fw-bold">Prénoms</label>
                <input type="text" class="form-control" id="prenoms_user" placeholder="Prénoms"
                    v-model="formData.prenoms">
                <small class="text-danger" v-if="errors['prenoms']">{{ errors['prenoms'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="telephone_user" class="form-label fw-bold">Téléphone*</label>
                <input type="text" class="form-control" id="telephone_user" placeholder="Téléphone"
                    v-model="formData.telephone" required>
                <small class="text-danger" v-if="errors['telephone']">{{ errors['telephone'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="email_user" class="form-label fw-bold">Email*</label>
                <input type="email" class="form-control" id="email_user" placeholder="Email" v-model="formData.email"
                    required>
                <small class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</small>
            </div>

            <div class="mb-3 col-md-12">
                <label for="adresse_user" class="form-label fw-bold">Adresse</label>
                <input type="text" class="form-control" id="adresse_user" placeholder="Adresse"
                    v-model="formData.adresse">
                <small class="text-danger" v-if="errors['adresse']">{{ errors['adresse'][0] }}</small>
            </div>

            <div class="mb-3 col-md-12">
                <label for="atelier_name" class="form-label fw-bold">Nom de l'atelier</label>
                <input type="text" class="form-control" id="atelier_name" placeholder="Nom de l'atelier"
                    v-model="formData.atelier_name">
                <small class="text-danger" v-if="errors['atelier_name']">{{ errors['atelier_name'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="password_user" class="form-label fw-bold">Mot de passe*</label>
                <div class="input-group">
                    <input :type="pwdShow ? 'text' : 'password'" class="form-control" id="password_user"
                        placeholder="Mot de passe" v-model="formData.password" required>
                    <span class="input-group-text" role="button" @click="pwdShow = !pwdShow">
                        <i v-if="!pwdShow" class="bi bi-eye"></i>
                        <i v-if="pwdShow" class="bi bi-eye-slash"></i>
                    </span>
                </div>
                <small class="text-danger" v-if="errors['password']">{{ errors['password'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="password_confirmation_user" class="form-label fw-bold">Confirmer le mot de passe*</label>
                <div class="input-group">
                    <input :type="pwdConfirmShow ? 'text' : 'password'" class="form-control"
                        id="password_confirmation_user" placeholder="Confirmer le mot de passe"
                        v-model="formData.password_confirmation" required>
                    <span class="input-group-text" role="button" @click="pwdConfirmShow = !pwdConfirmShow">
                        <i v-if="!pwdConfirmShow" class="bi bi-eye"></i>
                        <i v-if="pwdConfirmShow" class="bi bi-eye-slash"></i>
                    </span>
                </div>
                <small class="text-danger" v-if="errors['password_confirmation']">{{ errors['password_confirmation'][0] }}</small>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col text-end">
                <button class="btn btn-primary" @click="save"><i class="bi bi-person-plus me-1"></i>S'inscrire</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import { useUserStore } from '@/store/userStore';

export default {
    name: 'RegisterForm',
    mixins: [formMixin],
    data: () => ({
        pwdShow: false,
        pwdConfirmShow: false,
        url: 'auth/register'
    }),
    computed: {
        userStore: () => useUserStore()
    },
    methods: {
        afterSave() {
            this.userStore.setUser(this.apiResponse.data);
            this.userStore.setToken(this.apiResponse.token);
            const route = this.$router.resolve({ name: 'home' });
            window.location.href = route.fullPath;
        }
    }
};
</script>
